export default __webpack_public_path__ + "static/media/330_dummy2016-fashion01-mobile-de.65a14a54.png";